import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const als: AnswerPathTreeNode = {
  path: 'als',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAlsDetails }],
};
